import { Card, CardContent } from "@/components/ui/card";
import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Jessica Tan",
    role: "Software Engineer at Google",
    quote: "I landed 3 interviews in my first week after switching to AI Resume Studio. The ATS optimization made all the difference.",
    rating: 5,
  },
  {
    name: "Ryan Mitchell",
    role: "Marketing Director",
    quote: "The AI-assisted mode saved me hours. It captured my experience perfectly and the templates look incredibly professional.",
    rating: 5,
  },
  {
    name: "Anika Patel",
    role: "UX Designer at Spotify",
    quote: "I love the live web resume feature. Sharing a link instead of a PDF really helped me stand out from other candidates.",
    rating: 5,
  },
  {
    name: "James Okafor",
    role: "Recent Graduate",
    quote: "As a new grad with limited experience, the AI suggestions helped me highlight my projects and skills in the best way possible.",
    rating: 5,
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-card/50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="font-display text-3xl font-bold text-foreground mb-3">
            Loved by Job Seekers
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Join thousands who've landed their dream roles with AI Resume Studio
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {testimonials.map((t) => (
            <div key={t.name} className="animate-fade-in">
              <Card className="h-full hover:shadow-md transition-shadow">
                <CardContent className="p-6 flex flex-col gap-4">
                  <div className="flex gap-0.5">
                    {Array.from({ length: t.rating }).map((_, idx) => (
                      <Star
                        key={idx}
                        className="w-4 h-4 fill-warning text-warning"
                      />
                    ))}
                  </div>
                  <p className="text-sm text-muted-foreground leading-relaxed italic">
                    "{t.quote}"
                  </p>
                  <div className="mt-auto pt-2 border-t border-border">
                    <p className="font-semibold text-sm text-foreground">
                      {t.name}
                    </p>
                    <p className="text-xs text-muted-foreground">{t.role}</p>
                  </div>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
